/**
 * @generated SignedSource<<a3a7faa5058c2eb49239f0ddce33b7ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamUpdatesViewQuery$variables = {
  cloudId?: string | null;
  shouldFetchUpdatesTabData: boolean;
  teamId: string;
  workspaceUUID: string;
};
export type TeamUpdatesViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamUpdatesMainColumn">;
};
export type TeamUpdatesViewQuery = {
  response: TeamUpdatesViewQuery$data;
  variables: TeamUpdatesViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchUpdatesTabData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = {
  "kind": "Variable",
  "name": "teamId",
  "variableName": "teamId"
},
v6 = {
  "kind": "Variable",
  "name": "workspaceUUID",
  "variableName": "workspaceUUID"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "watching"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v5/*: any*/),
  (v6/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v13 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v14 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v15 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v16 = {
  "kind": "ScalarField",
  "name": "picture"
},
v17 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v18 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v19 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v9/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v16/*: any*/),
        (v17/*: any*/),
        (v7/*: any*/),
        (v18/*: any*/)
      ]
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "ari"
},
v21 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v9/*: any*/)
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v23 = {
  "kind": "ScalarField",
  "name": "key"
},
v24 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v25 = [
  (v9/*: any*/),
  (v24/*: any*/)
],
v26 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v27 = {
  "kind": "ScalarField",
  "name": "type"
},
v28 = {
  "kind": "ScalarField",
  "name": "summary"
},
v29 = [
  (v23/*: any*/),
  (v20/*: any*/),
  (v9/*: any*/)
],
v30 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ]
  },
  (v15/*: any*/),
  (v9/*: any*/)
],
v31 = {
  "kind": "ScalarField",
  "name": "count"
},
v32 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v33 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v32/*: any*/),
            (v20/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v24/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v16/*: any*/),
                    (v7/*: any*/),
                    (v18/*: any*/),
                    (v17/*: any*/)
                  ]
                },
                (v9/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ]
},
v34 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v7/*: any*/)
      ]
    },
    (v9/*: any*/)
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v36 = {
  "kind": "ScalarField",
  "name": "label"
},
v37 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v38 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v37/*: any*/)
},
v39 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v40 = {
  "alias": "tooltip",
  "args": (v39/*: any*/),
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(longFormat:true)"
},
v41 = {
  "alias": "localizedTooltip",
  "args": (v39/*: any*/),
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v37/*: any*/),
  "storageKey": "localizedLabel(longFormat:true)"
},
v42 = {
  "kind": "ScalarField",
  "name": "overdue"
},
v43 = [
  (v35/*: any*/),
  (v36/*: any*/),
  (v38/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/)
],
v44 = {
  "kind": "ScalarField",
  "name": "value"
},
v45 = {
  "concreteType": "CompletionProjectState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v44/*: any*/),
    (v36/*: any*/),
    (v38/*: any*/)
  ]
},
v46 = {
  "kind": "ScalarField",
  "name": "archived"
},
v47 = {
  "kind": "ScalarField",
  "name": "title"
},
v48 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v43/*: any*/)
},
v49 = {
  "kind": "ScalarField",
  "name": "url"
},
v50 = [
  (v9/*: any*/)
],
v51 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v52 = [
  (v44/*: any*/),
  (v9/*: any*/)
],
v53 = {
  "kind": "ScalarField",
  "name": "subType"
},
v54 = {
  "kind": "ScalarField",
  "name": "time"
},
v55 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v56 = {
  "kind": "ScalarField",
  "name": "score"
},
v57 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v55/*: any*/),
    (v38/*: any*/),
    (v44/*: any*/),
    (v56/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamUpdatesViewQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          {
            "kind": "Variable",
            "name": "shouldFetchUpdatesTabData",
            "variableName": "shouldFetchUpdatesTabData"
          },
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TeamUpdatesMainColumn"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamUpdatesViewQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByTeamId",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "teamId"
          },
          (v9/*: any*/)
        ]
      },
      {
        "condition": "shouldFetchUpdatesTabData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "UpdateConnection",
            "kind": "LinkedField",
            "name": "updatesWithTeam",
            "plural": false,
            "selections": [
              {
                "concreteType": "UpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v12/*: any*/),
                              (v21/*: any*/),
                              (v9/*: any*/),
                              (v8/*: any*/),
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchProject"
                                  },
                                  (v22/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "private"
                              },
                              {
                                "concreteType": "Icon",
                                "kind": "LinkedField",
                                "name": "icon",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "shortName"
                                  }
                                ]
                              },
                              {
                                "concreteType": "IconURIs",
                                "kind": "LinkedField",
                                "name": "iconUrl",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "ThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "square",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "light"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "dark"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "transparent"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v23/*: any*/),
                              (v7/*: any*/),
                              {
                                "concreteType": "ProjectUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": (v25/*: any*/)
                              },
                              (v26/*: any*/)
                            ]
                          },
                          (v24/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDate"
                          },
                          {
                            "concreteType": "ProjectChangelogItem",
                            "kind": "LinkedField",
                            "name": "changelog",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "newValue"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "oldValue"
                              },
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "LearningConnection",
                            "kind": "LinkedField",
                            "name": "learnings",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "LearningEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Learning",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v12/*: any*/),
                                      (v9/*: any*/),
                                      (v28/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "description"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v20/*: any*/),
                                          {
                                            "concreteType": "Project",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": (v29/*: any*/)
                                          },
                                          {
                                            "concreteType": "Goal",
                                            "kind": "LinkedField",
                                            "name": "goal",
                                            "plural": false,
                                            "selections": (v29/*: any*/)
                                          },
                                          {
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "creator",
                                            "plural": false,
                                            "selections": (v30/*: any*/)
                                          },
                                          (v24/*: any*/),
                                          {
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "lastEditedBy",
                                            "plural": false,
                                            "selections": (v30/*: any*/)
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "lastEditedDate"
                                          }
                                        ],
                                        "type": "Highlight",
                                        "abstractKey": "__isHighlight"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          },
                          (v33/*: any*/),
                          (v32/*: any*/),
                          (v34/*: any*/),
                          {
                            "concreteType": "TargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": (v43/*: any*/)
                          },
                          {
                            "alias": "newProjectState",
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v36/*: any*/),
                              (v38/*: any*/),
                              (v45/*: any*/)
                            ]
                          },
                          (v28/*: any*/),
                          {
                            "concreteType": "UpdateNote",
                            "kind": "LinkedField",
                            "name": "notes",
                            "plural": true,
                            "selections": [
                              (v12/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v28/*: any*/),
                              (v9/*: any*/),
                              (v11/*: any*/)
                            ]
                          },
                          (v48/*: any*/),
                          {
                            "alias": "oldProjectState",
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              (v38/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "MilestoneConnection",
                            "kind": "LinkedField",
                            "name": "milestones",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MilestoneEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Milestone",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v9/*: any*/),
                                      (v47/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetDate"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetDateType"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "status"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v49/*: any*/),
                                  {
                                    "concreteType": "Goal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "GoalUpdate"
                              }
                            ],
                            "type": "Update",
                            "abstractKey": "__isUpdate"
                          }
                        ],
                        "type": "ProjectUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v12/*: any*/),
                          (v19/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v20/*: any*/),
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v12/*: any*/),
                              (v21/*: any*/),
                              (v9/*: any*/),
                              (v8/*: any*/),
                              {
                                "concreteType": "TownsquareGoalCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchGoal"
                                  },
                                  (v22/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "parentGoal",
                                "plural": false,
                                "selections": (v50/*: any*/)
                              },
                              (v23/*: any*/),
                              (v7/*: any*/),
                              {
                                "concreteType": "GoalIcon",
                                "kind": "LinkedField",
                                "name": "icon",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                  }
                                ]
                              },
                              {
                                "concreteType": "GoalUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": (v25/*: any*/)
                              },
                              (v26/*: any*/),
                              {
                                "concreteType": "GoalProgress",
                                "kind": "LinkedField",
                                "name": "progress",
                                "plural": false,
                                "selections": [
                                  (v51/*: any*/),
                                  (v27/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "GoalConnection",
                                "kind": "LinkedField",
                                "name": "subGoals",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "MetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "MetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "startValue"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "targetValue"
                                          },
                                          (v9/*: any*/),
                                          {
                                            "concreteType": "MetricValue",
                                            "kind": "LinkedField",
                                            "name": "snapshotValue",
                                            "plural": false,
                                            "selections": (v52/*: any*/)
                                          },
                                          {
                                            "concreteType": "Metric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v7/*: any*/),
                                              (v27/*: any*/),
                                              (v53/*: any*/),
                                              (v46/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "source"
                                              },
                                              {
                                                "concreteType": "MetricValue",
                                                "kind": "LinkedField",
                                                "name": "latestValue",
                                                "plural": false,
                                                "selections": [
                                                  (v54/*: any*/),
                                                  (v9/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v24/*: any*/),
                          {
                            "concreteType": "GoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "GoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      },
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": [
                                          (v44/*: any*/),
                                          (v9/*: any*/),
                                          (v54/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v7/*: any*/),
                                          (v27/*: any*/),
                                          (v53/*: any*/),
                                          (v46/*: any*/),
                                          {
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 100
                                              },
                                              {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": [
                                                  "TIME_DESC"
                                                ]
                                              }
                                            ],
                                            "concreteType": "MetricValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "MetricValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "MetricValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v44/*: any*/),
                                                      (v54/*: any*/),
                                                      (v9/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": (v52/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalProgress",
                            "kind": "LinkedField",
                            "name": "newProgress",
                            "plural": false,
                            "selections": [
                              (v27/*: any*/),
                              (v51/*: any*/)
                            ]
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 50
                              }
                            ],
                            "concreteType": "GoalBundledUpdateConnection",
                            "kind": "LinkedField",
                            "name": "bundledUpdates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GoalBundledUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Goal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "GoalProgress",
                                        "kind": "LinkedField",
                                        "name": "progress",
                                        "plural": false,
                                        "selections": [
                                          (v51/*: any*/)
                                        ]
                                      },
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "bundledUpdates(first:50)"
                          },
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": "newGoalState",
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v55/*: any*/),
                              (v38/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v38/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              {
                                "concreteType": "TargetDateRange",
                                "kind": "LinkedField",
                                "name": "dateRange",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "end"
                                  }
                                ]
                              }
                            ]
                          },
                          (v28/*: any*/),
                          {
                            "concreteType": "UpdateNote",
                            "kind": "LinkedField",
                            "name": "notes",
                            "plural": true,
                            "selections": [
                              (v46/*: any*/),
                              (v12/*: any*/),
                              (v47/*: any*/),
                              (v28/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v56/*: any*/)
                            ]
                          },
                          (v48/*: any*/),
                          {
                            "alias": "oldGoalState",
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": [
                              (v55/*: any*/),
                              (v38/*: any*/),
                              (v56/*: any*/),
                              (v44/*: any*/),
                              (v57/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v49/*: any*/)
                                ],
                                "type": "GoalUpdate"
                              }
                            ],
                            "type": "Update",
                            "abstractKey": "__isUpdate"
                          }
                        ],
                        "type": "GoalUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v50/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v10/*: any*/),
            "filters": [
              "teamId",
              "workspaceUUID"
            ],
            "handle": "connection",
            "key": "TeamUpdatesFeed_updatesWithTeam",
            "kind": "LinkedHandle",
            "name": "updatesWithTeam"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8bd7d466f05d76ef1277b72139932e4f",
    "id": null,
    "metadata": {},
    "name": "TeamUpdatesViewQuery",
    "operationKind": "query",
    "text": "query TeamUpdatesViewQuery(\n  $teamId: String!\n  $workspaceUUID: UUID!\n  $cloudId: String\n  $shouldFetchUpdatesTabData: Boolean!\n) {\n  ...TeamUpdatesMainColumn_3cVFlO\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment FollowTeamButton on Team {\n  id\n  teamId\n  name\n  watching\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchGoal\n  }\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newGoalState: newState {\n    ...GoalState\n  }\n  oldGoalState: oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateMetricChart\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  bundledUpdates(first: 50) {\n    edges {\n      goal {\n        progress {\n          percentage\n        }\n        id\n      }\n    }\n  }\n  goal {\n    id\n    progress {\n      percentage\n    }\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n    ...MetricChart\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  missedUpdate\n  creationDate\n  editDate\n  metricUpdate {\n    edges {\n      node {\n        newValue {\n          time\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateMetricChart on GoalUpdate {\n  creationDate\n  newDueDate {\n    dateRange {\n      end\n    }\n  }\n  newState {\n    value\n    score\n  }\n  metricUpdate {\n    edges {\n      node {\n        newTargetValue\n        metric {\n          name\n          type\n          subType\n          archived\n          values(first: 100, sort: [TIME_DESC]) {\n            edges {\n              node {\n                value\n                time\n                id\n              }\n            }\n          }\n          id\n        }\n        newValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newGoalState: newState {\n    value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment MissedProjectUpdateCard on ProjectUpdate {\n  id\n  ari\n  uuid\n  project {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop_PTxnb\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsSummary_data\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  ari\n  uuid\n  watching\n  capabilities {\n    canWatchProject\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  icon {\n    id\n    shortName\n  }\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectMissedUpdateLabel on ProjectUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  project {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newProjectState: newState {\n    ...ProjectState\n  }\n  oldProjectState: oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  project {\n    uuid\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateCardFooter on ProjectUpdate {\n  ari\n  updateType\n  missedUpdate\n  project {\n    ari\n    ...ProjectFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment ProjectUpdateCardHeader on ProjectUpdate {\n  project {\n    ...ProjectFollowButton\n    ...ProjectIcon\n    id\n    key\n    name\n  }\n}\n\nfragment ProjectUpdateCardInternal on ProjectUpdate {\n  id\n  ari\n  project {\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop\n  ...ProjectUpdateSummary\n  ...ProjectUpdateCardContentExtras\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectUpdateCardTop on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectUpdateCreationDate\n  ...ProjectUpdateStatus\n  ...ProjectMissedUpdateLabel\n}\n\nfragment ProjectUpdateCardTop_PTxnb on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectMissedUpdateLabel\n  missedUpdate\n}\n\nfragment ProjectUpdateCreationDate on ProjectUpdate {\n  id\n  project {\n    key\n    id\n  }\n  creationDate\n  editDate\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateStatus on ProjectUpdate {\n  newDueDate {\n    ...TargetDate\n  }\n  newProjectState: newState {\n    value\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateSummary on ProjectUpdate {\n  summary\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamUpdatesFeed_27J6QJ on Query {\n  updatesWithTeam(teamId: $teamId, workspaceUUID: $workspaceUUID, first: 10) @include(if: $shouldFetchUpdatesTabData) {\n    ...UpdatesFeed\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamUpdatesHeader on Team {\n  watching\n  name\n  teamId\n  ...FollowTeamButton\n}\n\nfragment TeamUpdatesMainColumn_3cVFlO on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    name\n    ...TeamUpdatesHeader\n    id\n  }\n  ...TeamUpdatesFeed_27J6QJ\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesFeed on UpdateConnection {\n  edges {\n    node {\n      __typename\n      ... on ProjectUpdate {\n        id\n        ...ProjectUpdateCard\n        project {\n          capabilities {\n            canCommentOnUpdates\n          }\n          id\n        }\n      }\n      ... on GoalUpdate {\n        id\n        ...GoalUpdateCard\n        goal {\n          capabilities {\n            canCommentOnUpdates\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n"
  }
};
})();

(node as any).hash = "7bbb4effe409772bc0f4b73c247000c0";

export default node;
